import { Input, Select } from "@chakra-ui/react";
import {
  HistoricoSolicitacaoFilters,
  MOTIVO_SEM_LANCE_LABELS,
  MotivoSemLance,
} from "@/models/auction-historico.model";

const campoStyles = {
  variant: "filled",
  height: { base: "56px", md: "48px" },
  bg: "white",
  color: "black",
  _focus: { bg: "white" },
  _hover: { bg: "white" },
  fontFamily: "Lexend Deca",
  fontSize: { base: "xs", md: "sm" },
};

interface CreditAuctionHistoricoExtraFiltersProps {
  filters: HistoricoSolicitacaoFilters;
  onChange: (next: HistoricoSolicitacaoFilters) => void;
}

export default function CreditAuctionHistoricoExtraFilters({
  filters,
  onChange,
}: CreditAuctionHistoricoExtraFiltersProps) {
  return (
    <>
      <Select
        {...campoStyles}
        width={{ base: "100%", md: "260px" }}
        flexShrink={0}
        aria-label="Motivo sem lance"
        value={filters.motivoSemLance}
        onChange={(ev) =>
          onChange({
            ...filters,
            motivoSemLance: ev.target.value as MotivoSemLance | "",
          })
        }
      >
        <option value="">Todos os motivos</option>
        {Object.values(MotivoSemLance).map((motivo) => (
          <option key={motivo} value={motivo}>
            {MOTIVO_SEM_LANCE_LABELS[motivo]}
          </option>
        ))}
      </Select>

      <Input
        {...campoStyles}
        width={{ base: "100%", md: "160px" }}
        flexShrink={0}
        placeholder="Código de erro"
        type="text"
        maxLength={40}
        value={filters.codigoErroLance}
        onChange={(ev) =>
          onChange({ ...filters, codigoErroLance: ev.target.value })
        }
      />

      <Input
        {...campoStyles}
        width={{ base: "100%", md: "160px" }}
        flexShrink={0}
        aria-label="Data inicial"
        title="Data inicial"
        type="date"
        max={filters.dataFinal || undefined}
        value={filters.dataInicial}
        onChange={(ev) => onChange({ ...filters, dataInicial: ev.target.value })}
      />

      <Input
        {...campoStyles}
        width={{ base: "100%", md: "160px" }}
        flexShrink={0}
        aria-label="Data final"
        title="Data final"
        type="date"
        min={filters.dataInicial || undefined}
        value={filters.dataFinal}
        onChange={(ev) => onChange({ ...filters, dataFinal: ev.target.value })}
      />
    </>
  );
}
